import SVGIcon, { type SVGIconProps } from "@ch/components/Icons/SVGIcon";
import type { FC } from "react";

type StepsIconProps = Partial<SVGIconProps>;

const StepsIcon: FC<StepsIconProps> = (props) => (
  <SVGIcon viewBox="0 0 100 100" {...props}>
    <circle cx="50" cy="40" r="14" stroke="currentColor" strokeWidth="5" />

    <path
      d="M20 92V84C20 65 35 60 50 60C65 60 80 65 80 84V92"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="5"
    />

    <path
      d="M35 10L20 25H32L17 45"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="5"
    />

    <path
      d="M65 10L80 25H68L83 45"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="5"
    />
  </SVGIcon>
);

export default StepsIcon;
